module.exports = __webpack_public_path__ + "static/bottom-right-hexagons-670ddbb22f39bd0f3b59dede8b6fa98d.png";